import { useTranslation } from 'react-i18next';
import { NewDropdown } from 'app/components/ui';
import { TagStatus, useUpdateTag } from 'entities/tag';

const ColorIndicator = ({ status }: { status: string }) => <span className={`new-dropdown__color-box new-dropdown__color-box--${status}`} />;

interface StatusFieldProps {
  tagId: string;
  documentSuperId: number;
  currentStatus: TagStatus;
  disabled?: boolean;
}

export const StatusField = ({ tagId, documentSuperId, currentStatus, disabled = false }: StatusFieldProps) => {
  const { t } = useTranslation('tag');

  const { mutate: updateTag } = useUpdateTag();

  const statusOptions: { value: TagStatus; label: string; icon: React.ReactNode }[] = [
    { value: 'approved', label: t('status.approved'), icon: <ColorIndicator status="approved" /> },
    { value: 'draft', label: t('status.draft'), icon: <ColorIndicator status="draft" /> },
    { value: 'verified', label: t('status.verified'), icon: <ColorIndicator status="verified" /> },
    { value: 'need_attention', label: t('status.needsAttention'), icon: <ColorIndicator status="needs-attention" /> },
  ];

  const handleUpdate = (newStatus: string) => {
    updateTag({
      id: tagId,
      status: newStatus as TagStatus,
      documentSuperId,
    });
  };

  if (disabled) {
    const current = statusOptions.find((o) => o.value === currentStatus);
    return (
      <div className="d-flex align-items-center gap-1">
        {current?.icon}
        {current?.label}
      </div>
    );
  }

  return <NewDropdown options={statusOptions} currentValue={currentStatus} onUpdate={handleUpdate} />;
};
